<template>
  <vbt-content-box
    :loading="isLoading"
    :loading-error="loadingError"
    :no-content="noContent"
    :go-back-btn="goBack"
    title="History"
  >
    <vbt-table
      :items="applicationHistory"
      :headers="headers"
    >
      <template #processed="{ item: { processed } }">
        {{ formatDisplayDate(processed) }}
      </template>
    </vbt-table>

    <vbt-pagination
      v-model="pageNum"
      :items-count="pagedItemsCount"
    />
  </vbt-content-box>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination } from '@mixins/factories';

import { formatDisplayDate } from '@helpers';

import {
  namespace as ApplicationsNamespace,
  ActionTypes as ApplicationsActionTypes,
} from '../store.type';

const dataLoadingOptions = {
  getterName: ApplicationsActionTypes.GET_APPLICATION_HISTORY,
  contentName: 'applicationHistory',
  parameterize: true,
  searchable: false,
};
const paginationOptions = { contentName: 'applicationHistory' };

const headers = Object.freeze([
  { text: 'Action', value: 'action' },
  { text: 'Processed By', value: 'processedBy' },
  { text: 'Role', value: 'role' },
  { text: 'Target User', value: 'targetUser' },
  { text: 'Processed Date', value: 'processed' },
  { text: 'Description', value: 'description' },
]);

export default {
  name: 'UmsApplicationHistory',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(ApplicationsNamespace, ['applicationHistory']),
  },
  methods: {
    ...mapActions(ApplicationsNamespace, [ApplicationsActionTypes.GET_APPLICATION_HISTORY]),
    formatDisplayDate,
  },
};
</script>
